import React, { useState, useEffect } from 'react';
import {
  SimpleView,
  GridView,
  Widget,
  FormInput,
  Table,
  Form,
  Row,
  Col,
  Button,
  FormResetButton,
  CompositeView,
} from '@digital/ui';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { ColumnProps } from 'antd/lib/table';
import { compareText, compareNumber } from '@app/helpers/comparators';
import { Icon } from 'antd';
import moment from 'moment';
import { dateFormat, formatarDataPadrao } from '@app/helpers/dateTimeFormats';
import {
  RelatorioPreContratacao,
  getRelatorioPreContratacao,
  getRelatorioPreContratacaoExcel,
} from '@app/api/relatorioPreContratacao';
import { thousandSeparator } from '@app/helpers/numbers';

const RelatorioPreContratacao = () => {
  const [items, setItems] = useState<RelatorioPreContratacao[]>();
  useEffect(() => {
    getRelatorioPreContratacao().then(data => {
      setItems(data);
    });
  }, []);

  const columns = () => {
    let tempColumns: ColumnProps<RelatorioPreContratacao>[] = [];

    tempColumns.push({
      title: 'Demanda',
      dataIndex: 'demandaTexto',
      width: '120px',
      sorter: (a, b) => compareText(a.demandaTexto, b.demandaTexto),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Demanda"
              name="demandaTexto"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.demandaTexto !== undefined && record.demandaTexto.toLowerCase().includes(value.toLowerCase()),
    });

    tempColumns.push({
      title: 'Data Abertura Demanda',
      dataIndex: 'dataAberturaDemanda',
      render: (text, record) => formatarDataPadrao(record.dataAberturaDemanda, true),
    });

    tempColumns.push({
      title: 'status',
      dataIndex: 'statusNome',
      width: '240px',
      sorter: (a, b) => compareText(a.statusNome, b.statusNome),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Status"
              name="statusNome"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.statusNome !== undefined && record.statusNome.toLowerCase().includes(value.toLowerCase()),
    });

    tempColumns.push({
      title: 'Tipo',
      dataIndex: 'tipoTexto',
      width: '120px',
      sorter: (a, b) => compareText(a.tipoTexto, b.tipoTexto),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Tipo"
              name="tipoTexto"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.tipoTexto !== undefined && record.tipoTexto.toLowerCase().includes(value.toLowerCase()),
    });

    let ehAditivo = true; //items.some(d => d.tipo === ETipoDemanda.Aditivo);
    if (ehAditivo) {
      tempColumns.push({
        title: 'Tipo de Aditivo',
        dataIndex: 'tipoAditivo',
      });
      tempColumns.push({
        title: 'Número CT',
        dataIndex: 'numeroCt',
      });
    }

    tempColumns.push({
      title: 'Objeto a ser Contratado',
      dataIndex: 'objeto',
      width: '480px',
    });
    tempColumns.push({
      title: 'expectativa de valor final',
      dataIndex: 'expectativa',
      sorter: (a, b) => compareNumberString(a.expectativa, b.expectativa),
      render: (text, record) => 'R$ ' + thousandSeparator(record.expectativa),
      width: '240px',
    });
    tempColumns.push({
      title: 'tipo de serviço',
      dataIndex: 'tipoServicoNome',
      width: '216px',
      sorter: (a, b) => compareText(a.tipoServicoNome, b.tipoServicoNome),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Tipo de Serviço"
              name="tipoServicoNome"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.tipoServicoNome !== undefined && record.tipoServicoNome.toLowerCase().includes(value.toLowerCase()),
    });

    tempColumns.push({
      title: 'Requisitante',
      dataIndex: 'requisitante',
    });

    tempColumns.push({
      title: 'Gestor Técnico',
      dataIndex: 'gestorTecnico',
      width: '166px',
      render: (text, record) => record.gestorTecnico && record.gestorTecnico != '' ? record.gestorTecnico : 'Não se aplica',
    });

    tempColumns.push({
      title: 'demandante',
      dataIndex: 'demandanteNome',
      width: '240px',
      sorter: (a, b) => compareText(a.demandanteNome, b.demandanteNome),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Demandante"
              name="demandanteNome"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.demandanteNome !== undefined && record.demandanteNome.toLowerCase().includes(value.toLowerCase()),
    });
    tempColumns.push({
      title: 'diretoria',
      dataIndex: 'diretoriaSigla',
      width: '122px',
      sorter: (a, b) => compareText(a.diretoriaSigla, b.diretoriaSigla),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Diretoria"
              name="diretoriaSigla"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.diretoriaSigla !== undefined && record.diretoriaSigla.toLowerCase().includes(value.toLowerCase()),
    });
    tempColumns.push({
      title: 'área',
      dataIndex: 'areaSigla',
      width: '122px',
      sorter: (a, b) => compareText(a.areaSigla, b.areaSigla),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Área"
              name="areaSigla"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.areaSigla !== undefined && record.areaSigla.toLowerCase().includes(value.toLowerCase()),
    });
    tempColumns.push({
      title: 'departamento',
      dataIndex: 'departamentoSigla',
      width: '122px',
      sorter: (a, b) => compareText(a.departamentoSigla, b.departamentoSigla),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Departamento"
              name="departamentoSigla"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.departamentoSigla !== undefined && record.departamentoSigla.toLowerCase().includes(value.toLowerCase()),
    });
    tempColumns.push({
      title: 'Comprador',
      dataIndex: 'comprador',
      width: '166px',
    });
    tempColumns.push({
      title: 'mão-de-obra em ptr?',
      dataIndex: 'haveraMaoDeObraEmPTR',
      width: '166px',
    });
    tempColumns.push({
      title: 'haverá sla',
      dataIndex: 'haveraSla',
      width: '166px',
    });
    tempColumns.push({
      title: 'despesas reembolsáveis?',
      dataIndex: 'haveraDespesasReembolsaveis',
      width: '166px',
    });
    tempColumns.push({
      title: 'resp. pré-contratação',
      dataIndex: 'respoPreContratacao',
      width: '240px',
      sorter: (a, b) => compareText(a.respoPreContratacao, b.respoPreContratacao),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Resp. Pré-Contratação"
              name="respoPreContratacao"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.respoPreContratacao !== undefined &&
        record.respoPreContratacao.toLowerCase().includes(value.toLowerCase()),
    });
    tempColumns.push({
      title: 'análise de privacidade',
      dataIndex: 'analisePrivacidade',
      width: '240px',
    });
    tempColumns.push({
      title: 'gov. aprovação',
      dataIndex: 'governancaAprovacao',
      width: '240px',
    });
    tempColumns.push({
      title: 'ddi',
      dataIndex: 'isDdi',
    });
    tempColumns.push({
      title: 'Data Início Status Atual',
      dataIndex: 'dataInicioStatusAtual',
      render: (text, record) => formatarDataPadrao(record.dataInicioStatusAtual, true),
    });
    tempColumns.push({
      title: 'Emergencial?',
      dataIndex: 'isEmergencial',
      width: '166px',
    });
    tempColumns.push({
      title: 'Direcionada?',
      dataIndex: 'isDirecionada',
      width: '166px',
    });
    tempColumns.push({
      title: 'Previsão Orçamentária',
      dataIndex: 'previsaoOrcamentaria',
      width: '166px',
    });
    tempColumns.push({
      title: 'N° RC',
      dataIndex: 'nrc',
      width: '166px',
    });
    tempColumns.push({
      title: 'Data de Abertura RC',
      dataIndex: 'dataAberturaRc',
      render: (text, record) => formatarDataPadrao(record.dataAberturaRc, true),
    });
    tempColumns.push({
      title: 'N° OC',
      dataIndex: 'noc',
      width: '166px',
    });
    tempColumns.push({
      title: 'Data de Abertura OC',
      dataIndex: 'dataAberturaOC',
      render: (text, record) =>
        record.dataAberturaOC ? moment(record.dataAberturaOC).format(dateFormat) : null,
      width: '166px',
    });
    tempColumns.push({
      title: 'Valor do Aditivo',
      dataIndex: 'valorAditivo',
      render: (text, record) => 'R$ ' + thousandSeparator(record.valorAditivo),
      width: '166px',
    });
    tempColumns.push({
      title: 'Prazo(Meses)',
      dataIndex: 'prazoMeses',
      width: '166px',
    });
    tempColumns.push({
      title: 'Tipo de Despesa',
      dataIndex: 'tipoDespesa',
      width: '166px',
    });
    tempColumns.push({
      title: 'Alocação de Custo',
      dataIndex: 'alocacaoCusto',
      width: '166px',
    });
    tempColumns.push({
      title: 'Descrição da Alocação de Custo',
      dataIndex: 'descricaoAlocacaoCusto',
      width: '166px',
    });
    tempColumns.push({
      title: 'Item de Serviço',
      dataIndex: 'itemServico',
      width: '166px',
    });
    tempColumns.push({
      title: 'Descrição Item de Serviço',
      dataIndex: 'descricaoItemServico',
      width: '166px',
    });
    tempColumns.push({
      title: 'Data Conclusão',
      dataIndex: 'dataConclusao',
      width: '166px',
      render: (text, record) =>
        record.dataConclusao ? moment(record.dataConclusao).format(dateFormat) : null,
    });
    tempColumns.push({
      title: 'atividade',
      dataIndex: 'atividade1',
      width: '260px',
    });
    tempColumns.push({
      title: 'data',
      children: [
        {
          title: 'início',
          dataIndex: 'atividade1Inicio',
          render: (text, record) =>
            record.atividade1Inicio ? moment(record.atividade1Inicio).format(dateFormat) : null,
        },
        {
          title: 'planejada',
          dataIndex: 'atividade1Planejado',
          render: (text, record) =>
            record.atividade1Planejado ? moment(record.atividade1Planejado).format(dateFormat) : null,
        },
        {
          title: 'realizada',
          dataIndex: 'atividade1Realizado',
          render: (text, record) =>
            record.atividade1Realizado ? moment(record.atividade1Realizado).format(dateFormat) : null,
        },
      ],
    });
    tempColumns.push({
      title: 'atividade',
      dataIndex: 'atividade2',
      width: '260px',
    });
    tempColumns.push({
      title: 'data',
      children: [
        {
          title: 'início',
          dataIndex: 'atividade2Inicio',
          render: (text, record) =>
            record.atividade2Inicio ? moment(record.atividade2Inicio).format(dateFormat) : null,
        },
        {
          title: 'planejada',
          dataIndex: 'atividade2Planejado',
          render: (text, record) =>
            record.atividade2Planejado ? moment(record.atividade2Planejado).format(dateFormat) : null,
        },
        {
          title: 'realizada',
          dataIndex: 'atividade2Realizado',
          render: (text, record) =>
            record.atividade2Realizado ? moment(record.atividade2Realizado).format(dateFormat) : null,
        },
      ],
    });
    tempColumns.push({
      title: 'atividade',
      dataIndex: 'atividade3',
      width: '260px',
    });
    tempColumns.push({
      title: 'data',
      children: [
        {
          title: 'início',
          dataIndex: 'atividade3Inicio',
          render: (text, record) =>
            record.atividade3Inicio ? moment(record.atividade3Inicio).format(dateFormat) : null,
        },
        {
          title: 'planejada',
          dataIndex: 'atividade3Planejado',
          render: (text, record) =>
            record.atividade3Planejado ? moment(record.atividade3Planejado).format(dateFormat) : null,
        },
        {
          title: 'realizada',
          dataIndex: 'atividade3Realizado',
          render: (text, record) =>
            record.atividade3Realizado ? moment(record.atividade3Realizado).format(dateFormat) : null,
        },
      ],
    });
    tempColumns.push({
      title: 'atividade',
      dataIndex: 'atividade4',
      width: '260px',
    });
    tempColumns.push({
      title: 'data',
      children: [
        {
          title: 'início',
          dataIndex: 'atividade4Inicio',
          render: (text, record) =>
            record.atividade4Inicio ? moment(record.atividade4Inicio).format(dateFormat) : null,
        },
        {
          title: 'planejada',
          dataIndex: 'atividade4Planejado',
          render: (text, record) =>
            record.atividade4Planejado ? moment(record.atividade4Planejado).format(dateFormat) : null,
        },
        {
          title: 'realizada',
          dataIndex: 'atividade4Realizado',
          render: (text, record) =>
            record.atividade4Realizado ? moment(record.atividade4Realizado).format(dateFormat) : null,
        },
      ],
    });
    tempColumns.push({
      title: 'atividade',
      dataIndex: 'atividade5',
      width: '260px',
    });
    tempColumns.push({
      title: 'data',
      children: [
        {
          title: 'início',
          dataIndex: 'atividade5Inicio',
          render: (text, record) =>
            record.atividade5Inicio ? moment(record.atividade5Inicio).format(dateFormat) : null,
        },
        {
          title: 'planejada',
          dataIndex: 'atividade5Planejado',
          render: (text, record) =>
            record.atividade5Planejado ? moment(record.atividade5Planejado).format(dateFormat) : null,
        },
        {
          title: 'realizada',
          dataIndex: 'atividade5Realizado',
          render: (text, record) =>
            record.atividade5Realizado ? moment(record.atividade5Realizado).format(dateFormat) : null,
        },
      ],
    });
    tempColumns.push({
      title: 'atividade',
      dataIndex: 'atividade6',
      width: '260px',
    });
    tempColumns.push({
      title: 'data',
      children: [
        {
          title: 'início',
          dataIndex: 'atividade6Inicio',
          render: (text, record) =>
            record.atividade6Inicio ? moment(record.atividade6Inicio).format(dateFormat) : null,
        },
        {
          title: 'planejada',
          dataIndex: 'atividade6Planejado',
          render: (text, record) =>
            record.atividade6Planejado ? moment(record.atividade6Planejado).format(dateFormat) : null,
        },
        {
          title: 'realizada',
          dataIndex: 'atividade6Realizado',
          render: (text, record) =>
            record.atividade6Realizado ? moment(record.atividade6Realizado).format(dateFormat) : null,
        },
      ],
    });
    tempColumns.push({
      title: 'atividade',
      dataIndex: 'atividade7',
      width: '260px',
    });
    tempColumns.push({
      title: 'data',
      children: [
        {
          title: 'início',
          dataIndex: 'atividade7Inicio',
          render: (text, record) =>
            record.atividade7Inicio ? moment(record.atividade7Inicio).format(dateFormat) : null,
        },
        {
          title: 'planejada',
          dataIndex: 'atividade7Planejado',
          render: (text, record) =>
            record.atividade7Planejado ? moment(record.atividade7Planejado).format(dateFormat) : null,
        },
        {
          title: 'realizada',
          dataIndex: 'atividade7Realizado',
          render: (text, record) =>
            record.atividade7Realizado ? moment(record.atividade7Realizado).format(dateFormat) : null,
        },
      ],
    });

    return tempColumns;
  };

  return (
    <CompositeView>
      <SimpleView>
        <GridView>
          <Widget title="Relatório Pré-Contratação">
            <div className="ant-app-unboxed-button">
              <Button
                type="link"
                icon="files-xls"
                onClick={() => {
                  getRelatorioPreContratacaoExcel();
                }}>
                Exportar
              </Button>
            </div>
            <PerfectScrollbar>
              <Table
                className="no-bold-table on-table-overflow"
                columns={columns()}
                dataSource={items || []}
                pagination={{ defaultPageSize: 50 }}
                rowKey="id"
              />
            </PerfectScrollbar>
          </Widget>
        </GridView>
      </SimpleView>
    </CompositeView>
  );
};

export default RelatorioPreContratacao;
